import { defineStore } from 'pinia'
import obfn from '@/utils/obfn'

const firstDate = obfn.getFirstDayOfYear()
const curDate = obfn.getCurDate()

interface Project {
  id: string;
  name: string;
  role: string;
  children: Project[];
}

interface Role {
  id: string;
  name: string;
}

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      userName: 'Anonymous',
      email: 'null@gmail.com',
      role: {},
      roles: [] as Role[],
      project: {} as Project,
      projects: [] as Project[],
      memberSince: '8/12/2020',
      is2FAEnabled: false,
      token: '',
      remeberMe: false,
      locale: 'cn',
      dashboardDate: {
        startDate: firstDate,
        endDate: curDate,
      },
      activeSidebarProject: {} as Project,
    }
  },
  actions: {
    toggle2FA() {
      this.is2FAEnabled = !this.is2FAEnabled
    },
    changeUserName(userName: string) {
      this.userName = userName
    },
    changeEmail(email: string) {
      this.email = email
    },
    roleSet(role: Role) {
      this.role = role
    },
    rolesSet(roles: Role[]) {
      this.roles = roles
    },
    changeProject(project: Project) {
      this.project = project
      this.role = project.role
    },
    clearProject() {
      this.project = {} as Project
      this.role = {} as Role
    },
    tokenSet(val: string) {
      this.token = val
    },
    tokenSetExpired() {
      this.token = ''
    },
    projectsSet(projects: Project[]) {
      this.projects = projects
    },
    activeSidebarProjectSet(project: Project) {
      this.activeSidebarProject = project
    },
  },
  persist: true,
})

